<template>
  <app-tooltip
    class="d-inline"
    :aria-label="t('literal.view_collected_amount_in_original_project_currency', { currency: project.currency })"
    v-if="project.currency !== currency"
  >
    <button
      class="tooltip"
      :aria-describedby="`default_amount_tooltip${project.id}`"
    >
      <app-money
        class="color--prim bold"
        :amount="amount"
      />
    </button>

    <template #popper>
      <app-money
        :id="`default_amount_tooltip${project.id}`"
        :amount="amount"
        :currency="project.currency"
      />
    </template>
  </app-tooltip>

  <app-money
    class="color--prim bold"
    :amount="amount"
    :currency="project.currency"
    v-else
  />
</template>

<script setup>
import { defineAsyncComponent } from 'vue'
import { useI18n } from '@/vendors/i18n'
import { storeToRefs } from 'pinia'
import { useCurrencyStore } from '@/stores/CurrencyStore'

import AppMoney from '&/atoms/AppMoney'
const AppTooltip = defineAsyncComponent(() => import('&/atoms/AppTooltip'))

defineProps({
  project: { type: Object, required: true },
  amount: { type: Object, required: true }
})

const { t } = useI18n()
const { currency } = storeToRefs(useCurrencyStore())
</script>

<style scoped lang="scss">
.tooltip {
  z-index: 20;
  position: relative;
  display: inline-block;
  cursor: help;
}
</style>